<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid d-flex flex-row justify-content-between">
      <a class="navbar-brand" href="javascript:void(0)">Voucher Management</a>
      <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo', company_uuid, 'voucher', 'form']">&#43; Add Voucher</a>
    </div>
  </nav>
  <hr/>
  <div class="row">
    <app-tablev2 #table></app-tablev2>
  </div>